import { FC } from 'react';
// components
import SandComponent from 'components/main/SandComponent/Edit';

const EditSandComponent: FC = () => <SandComponent />;

export default EditSandComponent;
